import React from 'react';
import { BreadcrumbsStyles as S } from './Breadcrumbs.styles';
export const dummyBreadcrumbs = {
    links: [
        {
            text: 'Level 1 item',
            url: '#',
        },
        {
            text: 'Level 2 item',
            url: '#',
        },
        {
            text: 'Current Page',
            url: '',
        },
    ],
};
const Breadcrumbs = (props) => {
    return (React.createElement(S.Container, { "data-no-padding": !!props.noPadding, "data-theme": props.theme, id: props.anchorId }, props.links.map((link, i) => (React.createElement(React.Fragment, null,
        i === props.links.length - 1 ? (React.createElement("span", { key: `Breadcrumbs_Link_${(link.text || link.url)?.replace(/ /g, '-')}_${i}` }, link.text)) : (React.createElement("a", { key: `Breadcrumbs_Link_${(link.text || link.url)?.replace(/ /g, '-')}_${i}`, href: link.url, target: link.target }, link.text)),
        i < props.links.length - 1 && (React.createElement(S.Spacer, { key: `Breadcrumbs_Spacer_${(link.text || link.url)?.replace(/ /g, '-')}_${i}` })))))));
};
export default Breadcrumbs;
